"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GATEWAY_COMMAND_SOCKET_PATH = void 0;
// Path of the browser command socket on gd-client-api.
exports.GATEWAY_COMMAND_SOCKET_PATH = '/gateway-command';
